export default "__VITE_ASSET__B_cygo2q__"